var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-margin-top-50", attrs: { id: "vendor-partners" } },
    [
      _vm.loaders.vendors
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("VendorPartnerships")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }